import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {newsletterTargetingBuilder_template} from "./newsletterTargetingBuilder_template";

declare var ko: any;

export class newsletterSegmentEdit_template extends vnTemplate {
    public targetingBuilder!: newsletterTargetingBuilder_template;

    protected initPartial(): void {
        this.targetingBuilder = new newsletterTargetingBuilder_template("targetingBuilder", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateHtml(): string {
        return /*html*/`
            <div class="form-header">
                <h3 class="form-title" data-bind="text: formTitle"></h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body full-width">
                    <div class="form-group newsletter-segment-title-row">
                        <div class="newsletter-segment-title-field">
                            <label class="form-label">Title</label>
                            <input class="input-text" type="text" data-bind="value: title, disable: isReadOnly">
                        </div>
                        <div class="newsletter-segment-active-field checkbox-fix">
                            <input type="checkbox" data-bind="checked: isActive, disable: isReadOnly" id="segment-active">
                            <label class="form-label icon i-check" for="segment-active">Active</label>
                        </div>
                    </div>
                    <strong class="form-sub-title">Criteria</strong>
                    ${this.targetingBuilder.getHtmlBuild()}
                    <div class="newsletter-segment-audience-accordion">
                        <strong class="form-sub-title newsletter-segment-audience-accordion-title icon i-dropdown-simple" data-bind="event: { click: onClickToggleAudienceTools }, css: { 'is-open': isAudienceToolsOpen }, attr: { 'aria-expanded': isAudienceToolsOpen() ? 'true' : 'false' }">Audience Tools</strong>
                        <div data-bind="visible: isAudienceToolsOpen">
                            <div class="form-group newsletter-segment-audience-tools">
                                <div class="newsletter-segment-audience-count">
                                    <button class="btn secondary" type="button" data-bind="disable: isPreviewLoading, css: { 'is-loading': isPreviewLoading }, event: { click: onClickPreview }">Calculate Count of Targeted Email Addresses</button>
                                    <span class="form-text" data-bind="visible: previewCount() !== null, text: 'Audience count: ' + previewCount()"></span>
                                    <!-- ko if: permissions()['website_user_export'] && permissions()['website_user_export'].read -->
                                    <button class="btn secondary icon i-export" type="button" data-bind="disable: isExportLoading, css: { 'is-loading': isExportLoading }, event: { click: onClickExport }">Export CSV of Targeted Email Addresses</button>
                                    <!-- /ko -->
                                </div>
                                <div class="newsletter-segment-audience-lookup">
                                    <label class="form-label">User Lookup</label>
                                    <textarea class="input-text newsletter-segment-lookup-input" data-bind="value: lookupEmail" placeholder="email@example.com, other@example.com"></textarea>
                                    <button class="btn secondary" type="button" data-bind="disable: isLookupLoading, css: { 'is-loading': isLookupLoading }, event: { click: onClickLookup }">Check if Email Addresses are Targeted</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <button data-bind="event: { click: onClickCancelEdit }" class="btn" type="button">Cancel</button>
                <button data-bind="visible: !isReadOnly(), event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
            </div>
            <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isLookupResultsVisible }">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form newsletter-segment-lookup-results-popup">
                        <div class="form-header">
                            <h3 class="form-title">Check Email Results</h3>
                            <button type="button" data-bind="event: { click: onClickCloseLookupResults }" class="close-button icon i-close-2"></button>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                                <div class="newsletter-segment-lookup-results-summary">
                                    <div class="newsletter-segment-lookup-results-stat">
                                        <strong data-bind="text: lookupTotalCount"></strong>
                                        <span>Checked</span>
                                    </div>
                                    <div class="newsletter-segment-lookup-results-stat is-match">
                                        <strong data-bind="text: lookupMatchCount"></strong>
                                        <span>Matched</span>
                                    </div>
                                    <div class="newsletter-segment-lookup-results-stat is-no-match">
                                        <strong data-bind="text: lookupNoMatchCount"></strong>
                                        <span>Not Matched</span>
                                    </div>
                                </div>
                                <div class="newsletter-segment-lookup-results-group is-match" data-bind="visible: lookupMatchCount() > 0">
                                    <h4 class="newsletter-segment-lookup-results-heading" data-bind="text: 'Matched Addresses (' + lookupMatchCount() + ')'"></h4>
                                    <ul class="newsletter-segment-lookup-results-list" data-bind="foreach: lookupMatchedResults">
                                        <li class="form-text"><span data-bind="text: email"></span><strong>Targeted</strong></li>
                                    </ul>
                                </div>
                                <div class="newsletter-segment-lookup-results-group is-no-match" data-bind="visible: lookupNoMatchCount() > 0">
                                    <h4 class="newsletter-segment-lookup-results-heading" data-bind="text: 'Not Matched Addresses (' + lookupNoMatchCount() + ')'"></h4>
                                    <ul class="newsletter-segment-lookup-results-list" data-bind="foreach: lookupUnmatchedResults">
                                        <li class="form-text"><span data-bind="text: email"></span><strong>Not Targeted</strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCloseLookupResults }" class="btn">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "newsletterSegmentEdit_template";
    }

    protected buildViewModel(): any {
        let self = this;
        let lookupResults = ko.observableArray([]);
        let viewModel: any = {
            id: ko.observable(""),
            title: ko.observable(""),
            isActive: ko.observable(true),
            isReadOnly: ko.observable(false),
            lookupEmail: ko.observable(""),
            lookupResult: ko.observable(""),
            lookupResults: lookupResults,
            lookupMatchedResults: ko.pureComputed(() => lookupResults().filter((result: any) => result.matches)),
            lookupUnmatchedResults: ko.pureComputed(() => lookupResults().filter((result: any) => !result.matches)),
            lookupMatchCount: ko.pureComputed(() => lookupResults().filter((result: any) => result.matches).length),
            lookupNoMatchCount: ko.pureComputed(() => lookupResults().filter((result: any) => !result.matches).length),
            lookupTotalCount: ko.pureComputed(() => lookupResults().length),
            isLookupResultsVisible: ko.observable(false),
            isLookupLoading: ko.observable(false),
            isPreviewLoading: ko.observable(false),
            isExportLoading: ko.observable(false),
            isAudienceToolsOpen: ko.observable(false),
            previewCount: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions(['newsletter_segments', 'website_user_export'])),
            onClickCancelEdit: function () {
                self.onClickCancelEdit();
            },
            onClickSave: function () {
                self.onClickSave();
            },
            onClickEdit: function () {
                self.onClickEdit();
            },
            onClickLookup: function () {
                self.onClickLookup();
            },
            onClickCloseLookupResults: function () {
                self.onClickCloseLookupResults();
            },
            onClickPreview: function () {
                self.onClickPreview();
            },
            onClickExport: function () {
                self.onClickExport();
            },
            onClickToggleAudienceTools: function () {
                self.onClickToggleAudienceTools();
            }
        };
        viewModel.formTitle = ko.pureComputed(function () {
            return viewModel.id() ? 'Edit Newsletter Segment' : 'Create Newsletter Segment';
        });

        return viewModel;
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large"];
    }

    public getViewModelForRequest(): any {
        return {
            id: this.getTemplateViewModel().id(),
            title: this.getTemplateViewModel().title(),
            isActive: this.getTemplateViewModel().isActive(),
            criteria: this.targetingBuilder.getCriteria()
        };
    }

    public getLookupRequest(): any {
        let emails = this.splitEmails(this.getTemplateViewModel().lookupEmail());
        return {
            email: emails[0] || "",
            emails: emails,
            criteria: this.targetingBuilder.getCriteria()
        };
    }

    public getPreviewRequest(): any {
        return {
            criteria: this.targetingBuilder.getCriteria()
        };
    }

    public setReferences(references: any): void {
        this.targetingBuilder.setReferences(references);
        this.getTemplateViewModel().permissions(references.permissions || this.getTemplateViewModel().permissions());
    }

    public setSegment(segment: any): void {
        this.getTemplateViewModel().id(segment.id || "");
        this.getTemplateViewModel().title(segment.title || "");
        this.getTemplateViewModel().isActive(segment.isActive === undefined ? true : !!segment.isActive);
        this.targetingBuilder.setCriteria(segment.criteria || null);
    }

    public setReadOnly(isReadOnly: boolean): void {
        this.getTemplateViewModel().isReadOnly(isReadOnly);
        this.targetingBuilder.setReadOnly(isReadOnly);
    }

    public setPreviewCount(count: any): void {
        this.getTemplateViewModel().previewCount(count);
    }

    public setLookupLoading(isLoading: boolean): void {
        this.getTemplateViewModel().isLookupLoading(isLoading);
    }

    public setPreviewLoading(isLoading: boolean): void {
        this.getTemplateViewModel().isPreviewLoading(isLoading);
    }

    public setExportLoading(isLoading: boolean): void {
        this.getTemplateViewModel().isExportLoading(isLoading);
    }

    public setLookupResult(results: Array<any>): void {
        let resultList = results || [];
        let messages = resultList.map((result) => {
            return result.email + (result.matches ? ' matches this segment.' : ' does not match this segment.');
        });
        this.getTemplateViewModel().lookupResults(resultList);
        this.getTemplateViewModel().lookupResult(messages.join(' '));
        this.getTemplateViewModel().isLookupResultsVisible(resultList.length > 0);
    }

    private onClickCancelEdit(): void {
        this.caller.cancelForm();
    }

    private onClickSave(): void {
        this.caller.save();
    }

    private onClickEdit(): void {
        this.caller.edit();
    }

    private onClickLookup(): void {
        this.caller.lookup();
    }

    private onClickCloseLookupResults(): void {
        this.getTemplateViewModel().isLookupResultsVisible(false);
    }

    private onClickPreview(): void {
        this.caller.preview();
    }

    private onClickExport(): void {
        this.caller.exportAudience();
    }

    private onClickToggleAudienceTools(): void {
        let viewModel = this.getTemplateViewModel();
        viewModel.isAudienceToolsOpen(!viewModel.isAudienceToolsOpen());
    }

    private splitEmails(value: string): Array<string> {
        if (!value) {
            return [];
        }

        return value.split(',').map((email) => email.trim()).filter((email) => email !== '');
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterSegmentEdit_template.ts